export default __webpack_public_path__ + "static/media/fad-filter-shelving-lo.7f113115.svg";